<template>
  <base-dialog
    :show="show"
    width="500px"
    data-testid="guidesDialog.dialog"
    title="Guided Tour Options"
    dialog-id="guidesDialog"
    @cancel-dialog="cancel"
  >
    <template #content>
      <div>Please select one of the tours:</div>
      <div class="guides-container">
        <v-list>
          <v-list-item
            v-for="guide in onboardingGuides"
            :key="onboardingGuides.indexOf(guide) + 1"
            class="guide-list-item"
            @click="select(guide)"
          >
            <v-list-item-title>{{ onboardingGuides.indexOf(guide) + 1 }}. {{ guide.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </div>
    </template>
    <template #footer>
      <v-btn-dialog-action @click="cancel">Cancel</v-btn-dialog-action>
    </template>
  </base-dialog>
</template>

<script setup lang="ts">
import { TourEventBus } from "../event-bus";
import { tutorial as guide01 } from "./steps/01-ui-guide";
import { shortcutsGuide } from "./steps/02-shortcuts-guide";
import BaseDialog from "../shared/BaseDialog.vue";
import { computed } from "vue";

const emit = defineEmits(["cancel"]);
const compProps = defineProps<{ modelValue: boolean }>();

const onboardingGuides = [shortcutsGuide, guide01];

function cancel() {
  emit("cancel");
}

const show = computed(() => {
  return compProps.modelValue;
});

function select(guide) {
  cancel();
  TourEventBus.emit("startOnboarding", guide.steps);
}
</script>

<style scoped></style>
